import _ from 'lodash';

const getters = {
  getSettings: state => {
    return state.settings;
  },
  getAppInfo: state => {
    return state.appInfo;
  },
  getPanelUpdateInfo: state => {
    return state.panelUpdateInfo;
  },
  getAddonsUpdateInfo: state => {
    return state.addonsUpdateInfo;
  },
  getInstalledAddons: state => {
    return state.installedAddons;
  },
  getStateVariable: state => variableName => {
    return state[variableName];
  },
  getSites: state => {
    return state.sites;
  },
  getCurrentGroupId: state => {
    return state.currentGroupID;
  },
  getSitesByIdGroupId: state => {
    let currentGroupID = state.currentGroupID;
    if (currentGroupID == 'all') {
      return state.sites;
    }
    return _.filter(state.sites, site => {
      let groupIDs = site.groupIDs;
      if (!groupIDs) {
        return false;
      }
      return groupIDs.indexOf(currentGroupID) > -1;
    });
  },
  getGroups: state => {
    return state.groups;
  },
  getGroup: state => groupId => {
    return state.groups[groupId];
  },
  getLastReloadTime: state => {
    return state.lastReloadTime;
  },
  getRecentCommentsCount: state => {
    return state.recentCommentsCount;
  },
  getPanelHistory: state => {
    return state.panelHistory;
  },
  getSitesUpdates: state => {
    return state.sitesUpdates;
  },
  getUpdates: state => hiddenItem => {
    return _.filter(state.sitesUpdates, { hiddenItem: hiddenItem });
  },
  getVulnerabilityUpdates: state => vulnerability => {
    return _.filter(state.sitesUpdates, { vulnerability: true });
  },
  getUpdatesForSite: state => siteId => {
    return _.filter(state.sitesUpdates, { siteID: siteId });
  },
  getReloadStats: state => siteId => {
    return state.reloadStats[siteId];
  },
  getPluginsAndThemes: state => {
    return state.pluginsAndThemes;
  },
  getPluginsAndThemesForSite: state => siteId => {
    return _.filter(state.pluginsAndThemes, { siteID: siteId });
  },
  selectedSites: (state, getters) => {
    let sites = [];
    return _.filter(getters.getSitesByIdGroupId, { selected: true });
  },
  selectedSiteIds: (state, getters) => {
    let selectedSites = getters.selectedSites;
    return _.map(selectedSites, 'siteID');
  },
  selectedSitesCount: (state, getters) => {
    return getters.selectedSites.length;
  },
  getSiteById: state => id => {
    //return state.sites.find(site => todo.id === id);
  },
  getFavorites: (state, getters) => {
    return state.favorites;
  },
  getClientPluginUpdateSites: (state, getters) => {
    return state.clientPluginUpdateSites;
  },
  getTopBarMenus: (state, getters) => {
    return state.menus;
  },
  isStoppedHistoryCheckCall: state => {
    return state.stopHistoryCheckCall;
  },
  getEditSiteMenu: state => {
    return state.editSiteMenu;
  },
  getSettingsMenu: state => {
    return state.settingsMenu;
  },
  getSiteInfoMenu: state => {
    return state.siteInfoMenu;
  },
  getCurrentUserInfo: state => {
    return state.currentUserInfoV3;
  },
  getInitPage: state => {
    return state.initPage;
  }
};

export default getters;
